import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';

const NotFoundLazy = React.lazy(() => import('../NotFound/NotFound'));

const NotFoundRoute = () => {
  return (
    <SuspenseWrapper>
      <NotFoundLazy />
    </SuspenseWrapper>
  );
};

export { NotFoundRoute };
